import { WorkspacePublicConfig } from './types';

export const DATA_PAGE_UPLOAD_URL = `${process.env.DATA_PAGE_UPLOAD_URL}`;
export const DATA_SESSION_UPLOAD_URL = `${process.env.DATA_SESSION_UPLOAD_URL}`;
export const DATA_SESSION_UPDATE_URL = `${process.env.DATA_SESSION_UPDATE_URL}`;
export const DATA_BUNDLE_UPLOAD_URL = `${process.env.DATA_BUNDLE_UPLOAD_URL}`;
export const CONFIG_STORAGE_BASE_URL = `${process.env.CONFIG_STORAGE_BASE_URL}`;

export const CONFIG_ENABLED = false;

export const WATCHER_MODE = 'lean';

export const EVENT_INPUT = 'input';
export const EVENT_MOUSE_MOVE = 'mousemove';
export const EVENT_VISIBLE_ELEMENT = 'visible';
export const EVENT_SUBMIT = 'submit';
export const EVENT_FOCUS_OUT = 'focusout';
export const EVENT_PAGE_HIDE = 'pagehide';
export const EVENT_VISIBILITY_CHANGE = 'visibilitychange';

export const UPFLOWY_INTENT_SCRIPT_SELECTOR = 'script[src*="upflowy-intent"],script[src*="upflowy-watcher"]';

export const DEFAULT_DETECTION_DURATION = 500;
export const UPFLOWY_SESSION_NAME = '_upintent_session';
export const UPFLOWY_ANONYMOUS_USER = '_upintent_anonymous';
export const UPFLOWY_DOM_WATCHED = 'data-upflowy-watched';
export const UPFLOWY_DOM_ID = 'data-uwid';
export const SESSION_TIMEOUT = 30; // minutes
export const DATA_BUNDLE_MAX_LENGTH = 62000; // bytes

export const DATA_UPLOAD_TIMEOUT = 15000; // milliseconds
export const DATA_BUNDLE_STATUS_OPEN = 'OPEN'; // more data
export const DATA_BUNDLE_STATUS_CLOSED = 'CLOSED'; // pending upload
export const DATA_BUNDLE_STATUS_QUEUED = 'QUEUED'; // uploaded

export const SCRIPT_WORKSPACE_ID_PARAM = 'wid';

export const enum Time {
  Second = 1000,
  Minute = 60 * 1000,
  Hour = 60 * 60 * 1000,
  Day = 24 * 60 * 60 * 1000,
}

export const DEFAULT_WORKSPACE_PUBLIC_CONFIG: WorkspacePublicConfig = {
  clarityEnabled: false,
};

export const MAX_COOKIE_EXPIRING_DATE = new Date(2147483647 * 1000);
